import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-879861da"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "slider round" }, null, -1));
const _hoisted_2 = [
    _hoisted_1
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["switch", { checked: _ctx.modelValue, monocolor: _ctx.monocolor, readonly: _ctx.readonly }]),
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _hoisted_2, 2));
}
